import {
    FETCH_DAILY_HEART_RATE,
    FETCH_DAILY_HEART_RATE_SUCCESS,
    FETCH_DAILY_HEART_RATE_FAIL,
    DELETE_ABNORMAL_HEART_RATE_START,
    DELETE_ABNORMAL_HEART_RATE_SUCCESS,
    DELETE_ABNORMAL_HEART_RATE_FAIL
} from '../../actions/ActionTypes.js';

const INITIAL_STATE = {
    payload: {},
    dailyHeartRate: {},
    dailyHeartRateFetching: false,
    dailyHeartRateFetchFail: false,
    abnormalHeartRateDeleting: false,
    abnormalHeartRateDeleteSuccess: false,
    abnormalHeartRateDeleteFail: false
};

const fetchDailyHeartRateRequested = (state, action) => {
    return {
        ...state,
        dailyHeartRate: {
            ...state.dailyHeartRate
        },
        dailyHeartRateFetching: true,
        dailyHeartRateFetchFail: false
    };
};

const fetchDailyHeartRateSuccess = (state, action) => {
    return {
        ...state,
        dailyHeartRate: {
            ...state.dailyHeartRate,
            [action.displayName]: {
                ...state.dailyHeartRate[action.displayName],
                [action.calendarDate]: action.dailyHeartRate
            }
        },
        dailyHeartRateFetching: false,
        dailyHeartRateFetchFail: false
    };
};

const fetchDailyHeartRateFail = (state, action) => {
    return {
        ...state,
        dailyHeartRate: {
            ...state.dailyHeartRate,
            [action.displayName]: {
                ...state.dailyHeartRate[action.displayName],
                [action.calendarDate]: {}
            }
        },
        dailyHeartRateFetching: false,
        dailyHeartRateFetchFail: true
    };
};

const abnormalHeartRateDeleting = (state) => {
    if (!state.dailyHeartRate) {
        return state;
    }

    return {
        ...state,
        abnormalHeartRateDeleting: true,
        abnormalHeartRateDeleteSuccess: false
    };
};

const abnormalHeartRateDeleteFinished = (isSuccess) => (state, action) => {
    if (!state.dailyHeartRate) {
        return state;
    }

    const { eventTimestamp, calendarDate, displayName } = action.payload;
    const newAbnormalHRValuesArray = state.dailyHeartRate[displayName][calendarDate].abnormalHRValuesArray.filter(
        (listItem) => listItem[0] !== eventTimestamp
    );

    return {
        ...state,
        dailyHeartRate: {
            ...state.dailyHeartRate,
            [displayName]: {
                ...state.dailyHeartRate[action.displayName],
                [calendarDate]: {
                    ...state.dailyHeartRate[displayName][calendarDate],
                    abnormalHRValuesArray: newAbnormalHRValuesArray
                }
            }
        },
        abnormalHeartRateDeleting: false,
        abnormalHeartRateDeleteSuccess: isSuccess,
        abnormalHeartRateDeleteFail: !isSuccess
    };
};

const handlers = {
    [FETCH_DAILY_HEART_RATE]: fetchDailyHeartRateRequested,
    [FETCH_DAILY_HEART_RATE_SUCCESS]: fetchDailyHeartRateSuccess,
    [FETCH_DAILY_HEART_RATE_FAIL]: fetchDailyHeartRateFail,

    [DELETE_ABNORMAL_HEART_RATE_START]: abnormalHeartRateDeleting,
    [DELETE_ABNORMAL_HEART_RATE_SUCCESS]: abnormalHeartRateDeleteFinished(true),
    [DELETE_ABNORMAL_HEART_RATE_FAIL]: abnormalHeartRateDeleteFinished(false)
};

// ======= Actions =======
export function fetchDailyHeartRate(displayName, calendarDate, evictCache) {
    return {
        type: FETCH_DAILY_HEART_RATE,
        displayName: displayName,
        calendarDate: calendarDate,
        meta: {
            cacheTime: evictCache ? null : 120000
        }
    };
}

// ======= Selectors =======
export const getDailyHeartRate = (state, displayName, calendarDate) => {
    return state.dailyHeartRate.dailyHeartRate[displayName]
        ? state.dailyHeartRate.dailyHeartRate[displayName][calendarDate]
        : null;
};

export const isDailyHeartRateFetching = (state) => {
    return state.dailyHeartRate.dailyHeartRateFetching;
};

export const didDailyHeartRateFetchFail = (state) => {
    return state.dailyHeartRate.dailyHeartRateFetchFail;
};

export const isAbnormalHeartRateDeleting = (state) => {
    return state.dailyHeartRate.abnormalHeartRateDeleting;
};

// ======= Default =======
export default function dailyHeartRate(state = INITIAL_STATE, action = {}) {
    const handler = handlers[action.type];

    if (!handler) return state;
    return handler(state, action);
}
